import { Formio } from '@formio/js'
import Modal from 'bootstrap/js/dist/modal'
import { allData } from '../app'
import { checkBookExistsInAdvayta, removeBookFromAdvayta, updateBookInAdvayta } from '../server/advayta'
import {
    addItemToFirebase,
    readFromFirebase,
    readFromFirebaseByField,
    removeItemFromFirebase,
    updateItemInFirebase
} from '../server/firebase'
import { deleteByPath } from '../upload'
import { HMSToSeconds, secondsToHMS } from './audioForm'
import AudioListComponent from './AudioListComponent'
import FileComponent from './FileComponent'
import { closeRightPanel, openRightPanel } from './panels'
import { addRowInTable, deleteRow, updateRowInTable } from './tabulatorControl'
import { createSelectTagify } from './tagifySelectControl'
import { showErrorToast, showOkToast } from './toastControl.js'
import { showSpinnerOverlay, hideSpinnerOverlay } from './spinner.js'

function highlightText(value, longestMatches) {
    if (longestMatches) {
        const [startIndex, endIndex] = longestMatches
        return value.slice(0, startIndex) +
            '<span class="highlight">' + value.slice(startIndex, endIndex + 1) + '</span>' +
            value.slice(endIndex + 1)
    }
    return value
}

export function clearBookFormHighlight() {
    for (const form of forms) {
        const highlightDivs = form.element.querySelectorAll('.annotation-highlight')
        highlightDivs.forEach(div => {
            const textarea = div.previousElementSibling
            if (textarea && textarea.tagName === 'TEXTAREA') {
                textarea.style.display = ''
                div.remove()
            }
        })
    }
}

let forms = []
const languages = ['ru', 'en', 'de', 'it', 'uk']
const bookForm = document.getElementById('bookForm')

/**
 * Поля формы книги.
 * @type {Array<Object>}
 */
export const fields = [
    {
        type: 'textfield',
        key: 'title',
        label: 'Название',
        input: true,
        validate: {
            required: true,
            maxLength: 41
        }
    },
    {
        type: 'textfield',
        key: 'bookAuthor',
        label: 'Автор',
        input: true,
        properties: {
            listName: 'bookAuthor',
            fieldName: 'bookAuthor',
            props: ['key', 'value'],
            isSingle: true,
            isRequired: true
        }
    },
    {
        type: 'textfield',
        key: 'bookReader',
        label: 'Чтец',
        input: true,
        properties: {
            listName: 'bookReader',
            fieldName: 'bookReader',
            props: ['key', 'value'],
            isSingle: true,
            isRequired: true
        }
    },
    {
        type: 'number',
        key: 'pages',
        label: 'Количество страниц',
        input: true
    },
    {
        type: 'textfield',
        key: 'bookCategory',
        label: 'Категория',
        input: true,
        properties: {
            listName: 'bookCategory',
            fieldName: 'bookCategory',
            props: ['key', 'value'],
            isSingle: true,
            isRequired: true
        }
    },
    // {
    //     type: 'textfield',
    //     key: 'recomendation',
    //     label: 'Рекомендация',
    //     input: true
    // },
    {
        type: 'filefield',
        key: 'image',
        label: 'Изображение',
        input: true,
        properties: {
            accept: '.jpg, .jpeg, .png',
            folder: 'firebase/books/img'
        }
    },
    // {
    //     type: 'textfield',
    //     key: 'access',
    //     label: 'Доступ',
    //     input: true,
    //     properties: {
    //         listName: 'access',
    //         fieldName: 'access',
    //         props: ['key', 'value'],
    //         isSingle: true
    //     }
    // },
    {
        type: 'textfield',
        key: 'tags',
        label: 'Теги',
        input: true,
        properties: {
            listName: 'tags',
            fieldName: 'tags',
            props: ['key', 'value', 'color', 'bgColor'],
            isSingle: false,
            isPainted: true
        }
    },
    {
        type: 'textarea',
        key: 'annotation',
        label: 'Аннотация',
        input: true
    },
    // {
    //     type: 'textfield',
    //     key: 'content',
    //     label: 'Содержание',
    //     input: true
    // },
    {
        type: 'textfield',
        key: 'seo_title',
        label: 'SEO-заголовок',
        input: true
    },
    {
        type: 'textfield',
        key: 'seo_description',
        label: 'SEO-описание',
        input: true
    },
    {
        type: 'radio',
        key: 'format',
        label: 'Формат книги',
        defaultValue: 'epub',
        input: true,
        values: [
            { label: 'epub', value: 'epub' }
            // { label: 'pdf', value: 'pdf' },
            // { label: 'docx', value: 'docx' }
        ]
    },
    {
        type: 'checkbox',
        key: 'paid',
        label: 'Подписка',
        input: true
    },
    {
        type: 'textfield',
        key: 'link_shop',
        label: 'Ссылка на книгу в магазине',
        input: true,
        placeholder: 'Введите ссылку'
    },
    {
        type: 'textfield',
        key: 'link_shop_online',
        label: 'Ссылка на электронную книгу в магазине',
        input: true,
        placeholder: 'Введите ссылку'
    },
    {
        type: 'filefield',
        key: 'link',
        label: 'Ссылка на книгу (epub)',
        input: true,
        properties: {
            accept: '.epub',
            folder: 'firebase/books/epub'
        },
        placeholder: 'Введите ссылку'
    },
    {
        type: 'textfield',
        key: 'duration',
        label: 'Длительность',
        input: true,
        placeholder: 'ЧЧ:ММ:СС',
        inputMask: '99:99:99',
        disabled: true,
        attributes: {
            autocomplete: 'off'
        },
        validate: {
            pattern: '^[0-9]{2}:[0-5][0-9]:[0-5][0-9]$',
            customMessage: 'Введите длительность в формате ЧЧ:ММ:СС.'
        }
    },
    {
        type: 'audiolist',
        key: 'audiolist',
        label: 'Аудио ссылки',
        addAnotherPosition: 'top',
        input: true,
        components: []
    },
    {
        type: 'textfield',
        key: 'priceRub',
        label: 'Цена (RUB)',
        input: true,
        placeholder: 'Введите цену'
    },
    {
        type: 'textfield',
        key: 'priceEur',
        label: 'Цена (EUR)',
        input: true,
        placeholder: 'Введите цену'
    }
]

/**
 * Инициализирует форму для редактирования книги.
 * @returns {Promise<void>}
 */
export async function initBookForm() {
    Formio.Components.addComponent('audiolist', AudioListComponent)
    Formio.Components.addComponent('filefield', FileComponent)
    createLanguageTabs()
    await createForms()
    await createTagify()
}

/**
 * Создает компоненты Tagify для всех полей с поддержкой списка значений.
 * @returns {Promise<void>}
 */
async function createTagify() {
    for (const form of forms) {
        for (const { component } of form.components) {
            if (!component.properties?.listName) continue
            const list = component.properties.listName in allData ? Object.values(allData[component.properties.listName]) : []
            component.properties.tagify = createSelectTagify(list, {
                ...component.properties,
                elementId: `${component.id}-${component.path}`
            })
        }
    }
}

/**
 * Создает вкладки для языков формы.
 */
function createLanguageTabs() {
    bookForm.innerHTML = ''
    const ul = document.createElement('ul')
    ul.classList.add('nav', 'nav-tabs')

    const tabContent = document.createElement('div')
    tabContent.classList.add('tab-content')

    for (const i in languages) {
        const li = document.createElement('li')
        li.classList.add('nav-item')

        const a = document.createElement('a')
        a.setAttribute('href', '#')
        a.onclick = (event) => changeLanguageTab(event, i)
        if (i == 0) a.classList.add('active')
        a.classList.add('nav-link')
        a.textContent = languages[i]

        li.appendChild(a)
        ul.appendChild(li)

        const tabPane = document.createElement('div')
        tabPane.classList.add('tab-pane')
        if (i == 0) tabPane.classList.add('active')
        tabPane.innerHTML = `<div id="bookForm-${languages[i]}" class="formio" data-lang="${languages[i]}"></div>`
        tabContent.appendChild(tabPane)
    }
    bookForm.appendChild(ul)
    bookForm.appendChild(tabContent)
}

/**
 * Переключает активную вкладку для формы.
 * @param {Event} event Событие клика.
 * @param {number} index Индекс активной вкладки.
 */
function changeLanguageTab(event, index) {
    bookForm.querySelectorAll('.nav-link').forEach(
        e => e.classList.remove('active')
    )
    bookForm.querySelectorAll('.tab-pane').forEach(
        e => e.classList.remove('active')
    )
    bookForm.querySelectorAll('.tab-pane')[index].classList.add('active')
    event.target.classList.add('active')
}

/**
 * Создает формы для каждого языка.
 * @returns {Promise<Array>} Массив созданных форм.
 */
async function createForms() {
    const promises = []
    bookForm.querySelectorAll('.formio').forEach(
        e => {
            e.getAttribute('data-lang')
            promises.push(Formio.createForm(e, { components: fields }))
        }
    )
    forms = await Promise.all(promises)
    return forms
}

/**
 * Получает значения Tagify из компонентов формы.
 * @param {Array<Object>} components Компоненты формы.
 * @param {boolean} [fb=false] Указывает, нужно ли возвращать формат данных для Firebase.
 * @returns {Object} Значения компонентов формы.
 */
export function getTagifyValues(components, fb = false) {
    const values = {}
    for (const component of components) {
        if (!component.component.properties?.listName) continue
        // const input = component.element.querySelector(`#${component.component.id}-${component.component.path}`)
        // const value = input.__tagify.getCleanValue()
        let value = component.getValue()
        if (!value.length) continue
        value = JSON.parse(value)
        if (!component.component.properties.isSingle) {
            values[component.component.path] = !fb ? value : Object.assign(...value.map(i => ({ [i.key]: i.key })))
            continue
        }
        values[component.component.path] = !fb ? value[0] ?? null : value[0].key
    }
    return values
}

/**
 * Отображает форму для редактирования книги.
 * @param {Object} row Данные строки книги.
 */
export async function showEditBookForm(row) {
    const [, book] = await Promise.all([
        openRightPanel(),
        getBook(row.key)
    ])
    for (const form of forms) {
        const lang = form.element.getAttribute('data-lang')
        const data = book.find(e => e.lang === lang)
        if (!data) continue
        if (data?.duration) {
            data.duration = secondsToHMS(data.duration)
        }
        await form.setSubmission({ data })
        if (row.longestMatches && row.longestMatches.annotation) {
            const annotationComponent = form.components.find(comp => comp.component.key === 'annotation')
            if (annotationComponent && data.annotation) {
                const textareaElement = annotationComponent.element.querySelector('textarea')
                if (textareaElement) {
                    const highlightDiv = document.createElement('div')
                    highlightDiv.className = 'form-control annotation-highlight'
                    highlightDiv.style.minHeight = textareaElement.style.minHeight || '100px'
                    highlightDiv.style.whiteSpace = 'pre-wrap'
                    highlightDiv.style.overflowWrap = 'break-word'
                    highlightDiv.innerHTML = highlightText(data.annotation, row.longestMatches.annotation)

                    textareaElement.style.display = 'none'
                    textareaElement.parentNode.insertBefore(highlightDiv, textareaElement.nextSibling)
                }
            }
        }

        for (const component of form.components) {
            if (!component.component.properties?.listName || !row[component.component.path]) continue
            component.component.properties.tagify.removeAllTags()
            let value = []
            if (typeof data[component.component.path] === 'object') {
                value = Object.keys(data[component.component.path]).map(k => allData[component.component.path][k])
            } else {
                value = allData[component.component.path][data[component.component.path]]
            }
            if (!value) continue
            let tags = Array.isArray(value) ? value : component.component.properties.isSingle ? [value] : value
            tags = tags.filter(e => e)
            component.component.properties.tagify.addTags(tags)
            // let tags = row.tags;
            // component.component.properties.tagify.addTags(tags)
        }
    }
}

/**
 * Получает данные книги из Firebase.
 * @param {string} key Ключ книги.
 * @returns {Promise<Array>} Массив данных книги.
 */
export async function getBook(key) {
    const [parent, childs] = await Promise.all([
        readFromFirebase(`/books/${key}`),
        readFromFirebaseByField('books', 'parent', key)
    ])
    return [parent, ...childs]
}

/**
 * Сохраняет книгу в Firebase.
 * @returns {Promise<void>}
 */
export async function saveBook() {
    showSpinnerOverlay()
    let error = false
    let parent = null

    if (forms.find(form => form.element.getAttribute('data-lang') === 'ru' && !form.checkValidity(form.data, true))) {
        showErrorToast('Необходимо заполнить форму с русской версией книги')
        hideSpinnerOverlay()
        return false
    }

    const priceError = forms.some(form => {
        const priceEurFilled = form.data.priceEur !== null && form.data.priceEur !== undefined && form.data.priceEur !== ''
        const priceRubFilled = form.data.priceRub !== null && form.data.priceRub !== undefined && form.data.priceRub !== ''

        return (priceEurFilled && !priceRubFilled) || (!priceEurFilled && priceRubFilled)
    })

    if (priceError) {
        showErrorToast('Заполните цену в двух валютах')
        hideSpinnerOverlay()
        return false
    }

    // Обработка файлов для удаления
    try {
        await FileComponent.processAllFilesToDelete()
    } catch (error) {
        console.error('Ошибка при обработке файлов для удаления:', error)
        hideSpinnerOverlay()
        return false
    }

    for (const form of forms) {
        const audioListComponent = form.getComponent('audiolist') // Используйте реальный key вашего компонента
        if (audioListComponent?.processFilesToDelete) {
            await audioListComponent.processFilesToDelete()
        }
        const lang = form.element.getAttribute('data-lang')
        if (!form.checkValidity(form.data, true)) {
            if (lang === 'ru') error = true
            continue
        }
        if (form.audiolist && typeof form.audiolist === 'object' && !Object.keys(form.audiolist).length) {
            form.audiolist = []
        }
        const data = { parent, lang, ...form.data }
        if (data.audiolist && Array.isArray(data.audiolist)) {
            data.audiolist = data.audiolist.filter(e => e.url || e.chapter)

            for (const i in data.audiolist) {
                if (data.audiolist[i].duration && typeof data.audiolist[i].duration === 'string' && data.audiolist[i].duration.indexOf(':') > -1) {
                    data.audiolist[i].duration = HMSToSeconds(data.audiolist[i].duration)
                }
            }
        }

        const listFields = fields.filter(e => e?.properties?.listName)
        for (const field of listFields) {
            if (!data[field.key]) continue
            data[field.key] = ''
        }

        if (data.duration && typeof data.duration === 'string' && data.duration.indexOf(':') > -1) {
            data.duration = HMSToSeconds(data.duration)
        }

        const firebaseData = { ...data, ...getTagifyValues(form.components, true) }
        const tabulatorRowData = { ...data, ...getTagifyValues(form.components) }

        if (form.data.key) {
            const response = await updateBookInAdvayta({ ...tabulatorRowData, checkExists: true })

            if (response?.error) {
                hideSpinnerOverlay()
                return showErrorToast(response.message)
            }

            if (response) {
                firebaseData.link = tabulatorRowData.link = response.link
                firebaseData.image = tabulatorRowData.image = response.image

                if (response.audio && response.audio.length) {
                    for (const i in response.audio) {
                        firebaseData.audiolist[i] = tabulatorRowData.audiolist[i] = response.audio[i]
                    }
                }
            }

            await updateItemInFirebase(firebaseData, 'books')

            if (lang === 'ru') {
                parent = form.data.key
                updateRowInTable(form.data.key, tabulatorRowData)
            }
            continue
        }

        const bookExists = await checkBookExistsInAdvayta(firebaseData.title)

        if (bookExists) {
            hideSpinnerOverlay()
            return showErrorToast(`Книга ${firebaseData.title} уже существует`)
        }

        const key = await addItemToFirebase(firebaseData, 'books').catch(e => console.error(e))

        const response = await updateBookInAdvayta({ ...tabulatorRowData, key })

        if (response?.error) {
            hideSpinnerOverlay()
            removeItemFromFirebase(key, 'books')
            return showErrorToast(response.message)
        }

        if (response && response.link) {
            firebaseData.link = tabulatorRowData.link = response.link
            firebaseData.image = tabulatorRowData.image = response.image
        }
        showOkToast('Запись успешно создана')

        if (lang === 'ru') {
            parent = key
            addRowInTable({ key, ...tabulatorRowData })
        }
    }
    if (!error) {
        closeRightPanel()
    }
    hideSpinnerOverlay()
}

export async function deleteBook() {
    const parent = forms.find(e => e.data.lang === 'ru')
    if (!parent || !parent.data.key) return false
    const modal = new Modal(document.getElementById('confirmDeleteModalRec'))
    const modalBodyEl = document.querySelector('#confirmDeleteModalRec .modal-body p')
    const title = 'Удалить книгу'
    const addTitle = 'Это приведет к удалению всех файлов связанных с книгой'
    modalBodyEl.innerHTML = `
              <figure class="text-center">
              <blockquote class="blockquote">
                <p>${title} "${parent.data.title}"? <br/> ${addTitle}</p>
              </blockquote>
            </figure>
            `
    const delBtnModal = document.getElementById('confirmDeleteBtnRec')
    modal.show()
    delBtnModal.onclick = async () => {
        try {
            const spinnerEl = delBtnModal.querySelector('span.spinner-border')
            spinnerEl.classList.remove('d-none')
            delBtnModal.setAttribute('disabled', '')

            document.querySelectorAll('.upload-file-btn').forEach(el => {
                const input = el.parentNode.querySelector('input[type="text"]')
                if (input && input.value) {
                    deleteByPath(input.value)
                }
            })

            const result = await removeItemFromFirebase(parent.data.key, 'books')
            removeBookFromAdvayta(parent.data.key)
            deleteRow(parent.data.key)
            closeRightPanel()
            modal.hide()
            spinnerEl.classList.add('d-none')
            delBtnModal.removeAttribute('disabled')
            showOkToast('Книга успешно удалена')
            console.log(`${result}`)
        } catch (error) {
            console.log(error)
            showErrorToast('Не удалось удалить книгу')
        }
    }
}